// extracted by mini-css-extract-plugin
export default {"input":"input_input__DZprK","wrapper":"input_wrapper__mCnQM","inscription":"input_inscription__heZl9"};